export const MAX_PDF_ENTITLEMENT_ICONS = 3;
export const ALLOWED_IMAGE_TYPES = ['jpg', 'jpeg', 'png'];
export const BADGE_DATE_TIME_FORMAT = 'DD-MM-YYYY_HH-mm';
export const BADGE_NAME_MAX_LENGTH = 20;
export const DEFAULT_BADGE_BACKGROUND_COLOR = '000000';
export const DEFAULT_BADGE_TEXT_COLOR = 'ffffff';
export const DISPLAY_STATE_COUNTRIES = ['AUS', 'USA'];
export const FULL_METADATA_MODE_QUERY_PARAM = 'ftm';
export const PARTIAL_METADATA_MODE_QUERY_PARAM = 'ptm';
export const NON_BREAKING_SPACE = ' ';
export const NON_READABLE_IEN = '￥';
export const READABLE_IEN = '¥';
